import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20red%20and%20black%20abstract%20background%20with%20glowing%20spotlight%20effect%2C%20breaking%20news%20atmosphere%2C%20dark%20theatrical%20stage%20with%20intense%20warm%20lighting%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20mysterious%20and%20urgent%20vibe%2C%20editorial%20style%2C%20deep%20crimson%20and%20black%20gradient&width=1920&height=900&seq=hero-bg&orientation=landscape"
          alt="911爆料网 - 网红黑料明星塌房每日吃瓜"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            <h1 className="text-background-50 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-5">
              网红黑料 · 明星塌房
              <br />
              <span className="text-primary-400">每日吃瓜</span>第一时间追踪
            </h1>
            <p className="text-background-50/75 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              911爆料网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点，不延迟不掉线。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/wanghong-heiliao"
                className="px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap flex items-center gap-2 cursor-pointer"
              >
                立即追踪
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="px-7 py-3 border border-background-50/30 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>

          {/* Right Visual - Decorative */}
          <div className="flex-1 hidden lg:flex justify-center items-center">
            <div className="relative w-full max-w-md aspect-square">
              <div className="absolute inset-0 rounded-3xl bg-primary-500/20 backdrop-blur-sm border border-background-50/10 flex items-center justify-center">
                <div className="text-center">
                  <span className="block text-background-50 font-heading text-8xl font-black leading-none">911</span>
                  <span className="block text-primary-300 font-heading text-2xl font-bold mt-2">爆料追踪</span>
                  <div className="mt-6 flex items-center justify-center gap-2 text-background-50/60 text-sm">
                    <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                    实时更新中
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-background-50/50">
        <span className="text-xs">向下滚动</span>
        <i className="ri-arrow-down-line animate-bounce"></i>
      </div>
    </section>
  );
}